export default __webpack_public_path__ + "static/proxima-nova-700-99647dc556266d2c4b92859accc2a639.woff";